"use client";

/**
 * Marketing home UI. Public `/` and `app/[lang]` reuse this.
 */
import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { HomeLandingFaq } from "#/features/homePage/ui/landing/HomeLandingFaq";
import { HomeLandingHero } from "#/features/homePage/ui/landing/HomeLandingHero";
import { HomeLandingSections } from "#/features/homePage/ui/landing/HomeLandingSections";
import { useI18nContext } from "#/shared/hooks";
import { MainLayout } from "#/shared/ui/templates/MainLayout";
export const MarketingHomeView: React.FC = () => {
  const $ = _c(10);
  const {
    LL
  } = useI18nContext();
  const [pageScrollViewport, setPageScrollViewport] = useState(null);
  let t0;
  if ($[0] !== LL || $[1] !== pageScrollViewport) {
    t0 = <HomeLandingHero LL={LL} pageScrollViewport={pageScrollViewport} />;
    $[0] = LL;
    $[1] = pageScrollViewport;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  let t2;
  if ($[3] !== LL) {
    t1 = <HomeLandingSections LL={LL} />;
    t2 = <HomeLandingFaq LL={LL} />;
    $[3] = LL;
    $[4] = t1;
    $[5] = t2;
  } else {
    t1 = $[4];
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t0 || $[7] !== t1 || $[8] !== t2) {
    t3 = <MainLayout headerPosition="fixed" pageScrollViewportRef={setPageScrollViewport}>{t0}{t1}{t2}</MainLayout>;
    $[6] = t0;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};